/* Formulários montados a partir dos campos de cada categoria do catálogo. */

import { cat } from '../core/estado';
import { esc, parseNum, unidadeTela } from '../core/formato';
import type { Campo, Categoria } from '../tipos/api';
import { escLabel } from './componentes';

export const temPadrao = (c: Campo) => c.padrao !== null && c.padrao !== undefined;

export function opcoesCategorias(selecionada: string): string {
  return [1, 2, 3].map((e) => {
    const cs = cat().categorias.filter((c) => c.escopo === e);
    return cs.length
      ? `<optgroup label="${escLabel(e)}">${cs.map((c) => `<option value="${c.slug}" ${c.slug === selecionada ? 'selected' : ''}>${esc(c.nome)}</option>`).join('')}</optgroup>`
      : '';
  }).join('');
}

export function campoHtml(campo: Campo, valores: Record<string, string>, prefixo = 'f_'): string {
  const id = prefixo + campo.nome;
  const v = valores[campo.nome] ?? campo.padrao ?? '';
  let input: string;
  if (campo.tipo === 'opcoes') {
    const vazia = !campo.obrigatorio && !temPadrao(campo) ? '<option value="">—</option>' : '';
    input = `<select class="inp" id="${id}">${vazia}${campo.opcoes.map((o) => `<option ${String(o) === String(v) ? 'selected' : ''}>${esc(o)}</option>`).join('')}</select>`;
  } else if (campo.tipo === 'obra' || campo.tipo.startsWith('lista:')) {
    const itens = campo.tipo === 'obra' ? cat().obras : cat().listas[campo.tipo.slice(6)] || [];
    input = `<select class="inp" id="${id}"><option value="">Selecione…</option>${itens.map((i) =>
      `<option value="${esc(i.id)}" ${String(i.id) === String(v) ? 'selected' : ''}>${esc(i.nome)}${'unidade' in i && i.unidade ? ` (${esc(unidadeTela(i.unidade))})` : ''}</option>`).join('')}</select>`;
  } else {
    input = `<input class="inp" id="${id}" ${campo.tipo === 'data' ? 'type="date"' : ''} ${campo.tipo === 'numero' ? 'inputmode="decimal"' : ''} value="${esc(v)}">`;
  }
  return `<div class="field"><label for="${id}">${esc(campo.rotulo)}${campo.obrigatorio ? ' <span class="req">*</span>' : ''}</label>${input}${campo.dica ? `<div class="hint">${esc(campo.dica)}</div>` : ''}</div>`;
}

export function lerCampos(c: Categoria, prefixo = 'f_'): Record<string, string> {
  const vals: Record<string, string> = {};
  c.campos.forEach((x) => {
    const el = document.getElementById(prefixo + x.nome) as HTMLInputElement | null;
    if (el) vals[x.nome] = el.value.trim();
  });
  return vals;
}

/** Marca os campos obrigatórios vazios e converte números; devolve o corpo do POST. */
export function validaCampos(c: Categoria, vals: Record<string, string>, prefixo = 'f_') {
  const faltam: string[] = [];
  const payload: Record<string, string | number> = {};
  c.campos.forEach((x) => {
    const el = document.getElementById(prefixo + x.nome);
    const v = vals[x.nome];
    el?.classList.remove('err');
    if (!v) {
      if (x.obrigatorio && !temPadrao(x)) {
        faltam.push(x.rotulo);
        el?.classList.add('err');
      }
      return;
    }
    if (x.tipo === 'numero') {
      const n = parseNum(v);
      if (!Number.isFinite(n)) {
        faltam.push(`${x.rotulo} (número inválido)`);
        el?.classList.add('err');
        return;
      }
      payload[x.nome] = n;
    } else payload[x.nome] = v;
  });
  return { faltam, payload };
}
